import { DataBean } from "../DataBean";

export class BackupState extends DataBean {



    public async getDocumentVersionBackupCatalogByState(idDocument:any,documentDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getDocumentVersionBackupCatalogByState_Number_java.util.Date", [idDocument,documentDate]);
    }
}